import { useState, useEffect, useCallback } from "react";
import style from "./Carta.module.css";
import { 
  listarProductosByTipoCategoria, 
  listarTiposCategoria, 
  obtenerFavoritos, 
  agregarFavorito, 
  eliminarFavorito, 
  compartirPedido,
  obtenerAlergenos
} from "../../repositorios/apiServer";
import SoleteImage from "../../assests/imagenes/2-1.png";
import useStore from "../../useStore";
import { FaStar, FaShareAlt } from "react-icons/fa";
import SwipeContainer from "./SwipeContainer";

import apioImg from "../../assests/imagenes/alergenos/apio.png";
import crustaceosImg from "../../assests/imagenes/alergenos/Crustaceos.png";
import frutosSecosImg from "../../assests/imagenes/alergenos/frutossecos.png";
import glutenImg from "../../assests/imagenes/alergenos/Gluten.png";
import pescadoImg from "../../assests/imagenes/alergenos/pescado.png";
import huevosImg from "../../assests/imagenes/alergenos/huevos.png";
import lacteosImg from "../../assests/imagenes/alergenos/lacteos.png";
import moluscosImg from "../../assests/imagenes/alergenos/moluscos.png";
import mostazaImg from "../../assests/imagenes/alergenos/mostaza.png";
import sesamoImg from "../../assests/imagenes/alergenos/sesamo.png";
import sojaImg from "../../assests/imagenes/alergenos/soja.png";
import cacahueteImg from "../../assests/imagenes/alergenos/cacahuete.png";

const imagenesAlergenos = {
  "apio": apioImg,
  "Crustaceos": crustaceosImg,
  "frutossecos": frutosSecosImg,
  "Gluten": glutenImg,
  "pescado": pescadoImg,
  "huevos": huevosImg,
  "lacteos": lacteosImg,
  "moluscos": moluscosImg,
  "mostaza": mostazaImg,
  "sesamo": sesamoImg,
  "soja": sojaImg,
  "cacahuete": cacahueteImg
};

function throttle(func, limit) {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}

const Productos = ({ tipoCategoria, onProductoClick, onSinProductos, loadFavoritos = false }) => {
  const [productosPorTipo, setProductosPorTipo] = useState({});
  const [tiposCategoriasData, setTiposCategoriasData] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  const [favoritos, setFavoritos] = useState([]);
  const [favoritosCargados, setFavoritosCargados] = useState(false);
  const [compartiendo, setCompartiendo] = useState(null);
  const [alergenos, setAlergenos] = useState([]);

  const userToken = useStore((state) => state.userToken);

  useEffect(() => {
    const cargarAlergenos = async () => {
      try {
        const alergenosData = await obtenerAlergenos();
        if (Array.isArray(alergenosData)) {
          setAlergenos(alergenosData);
        }
      } catch (error) {
        console.error("Error al cargar alérgenos:", error);
        setAlergenos([]);
      }
    };
    
    cargarAlergenos();
  }, []);

  useEffect(() => {
    if (!cargando && !error) {
      const totalProductos = Object.values(productosPorTipo).reduce(
        (total, productos) => total + productos.length, 
        0
      );
      
      if (totalProductos === 0 && onSinProductos) {
        onSinProductos();
      }
    }
  }, [cargando, error, productosPorTipo, onSinProductos]);

  useEffect(() => {
    const cargarFavoritos = async () => {
      if (!userToken || favoritosCargados || !loadFavoritos) {
        return;
      }
      
      try {
        const favoritosData = await obtenerFavoritos(userToken);
        if (Array.isArray(favoritosData)) {
          const favIds = favoritosData.map(fav => {
            const id = fav._id || fav.id;
            return id ? id.toString() : null;
          }).filter(id => id !== null);
          
          setFavoritos(favIds);
        }
        setFavoritosCargados(true);
      } catch (error) {
        console.error("Error al cargar favoritos:", error);
      }
    };

    cargarFavoritos();
  }, [userToken, loadFavoritos, favoritosCargados]);

  useEffect(() => {
    let isMounted = true;
    
    const cargarProductosIniciales = async () => {
      if (!tipoCategoria && tipoCategoria !== 0) {
        if (isMounted) {
          setProductosPorTipo({});
          setTiposCategoriasData([]);
          setCargando(false);
        }
        return;
      }
      
      if (isMounted) {
        setCargando(true);
        setProductosPorTipo({});
      }
      
      try {
        const categoriaId = typeof tipoCategoria === 'object' 
          ? (tipoCategoria._id || tipoCategoria.id || '') 
          : tipoCategoria;
        
        const tiposCategoria = await listarTiposCategoria(categoriaId);
        
        if (!isMounted) return;
        
        setTiposCategoriasData(tiposCategoria || []);
        
        if (Array.isArray(tiposCategoria) && tiposCategoria.length > 0) {
          const productosPorTipoObj = {};
          const requests = tiposCategoria.map(async (tipo) => {
            const tipoId = tipo._id || tipo.id;
            const result = await listarProductosByTipoCategoria(tipoId);
            
            if (Array.isArray(result) && result.length > 0) {
              const idsUnicos = new Set();
              const productosFiltrados = result.filter(producto => {
                const id = producto._id || producto.id;
                if (!id || idsUnicos.has(id)) return false;
                idsUnicos.add(id);
                return true;
              });
              
              if (productosFiltrados.length > 0) {
                return { tipoId, productos: productosFiltrados };
              }
            }
            return null;
          });
          
          const results = await Promise.all(requests);
          
          if (!isMounted) return;
          
          results.forEach(result => {
            if (result) {
              productosPorTipoObj[result.tipoId] = result.productos;
            }
          });
          
          setProductosPorTipo(productosPorTipoObj);
        } else {
          const result = await listarProductosByTipoCategoria(categoriaId);
          
          if (!isMounted) return;
          
          if (Array.isArray(result) && result.length > 0) {
            setProductosPorTipo({ [categoriaId]: result });
            setTiposCategoriasData([{ _id: categoriaId, nombre: "Productos" }]);
          }
        }
      } catch (error) {
        console.error("Error al cargar productos:", error);
        if (isMounted) {
          setError("Error al cargar productos");
        }
      } finally {
        if (isMounted) {
          setCargando(false);
        }
      }
    };
    
    cargarProductosIniciales();
    
    return () => {
      isMounted = false;
    };
  }, [tipoCategoria]);

  const getId = (producto) => {
    if (!producto) return "";
    const id = (producto._id || producto.id || "").toString();
    return id.replace(/[{}"']/g, '');
  };

  const handleFavorito = useCallback(throttle(async (e, producto) => {
    e.stopPropagation();
    e.preventDefault();
    
    if (!userToken) {
      alert("Debes iniciar sesión para añadir favoritos");
      return;
    }
    
    const productoId = getId(producto);
    
    try {
      const esFavorito = favoritos.includes(productoId);
      
      const boton = e.currentTarget;
      if (esFavorito) {
        boton.classList.remove(style.active);
        setFavoritos(favoritos.filter(id => id !== productoId));
      } else {
        boton.classList.add(style.active);
        setFavoritos([...favoritos, productoId]);
      }
      
      if (esFavorito) {
        await eliminarFavorito(userToken, productoId);
      } else {
        await agregarFavorito(userToken, productoId, false);
      }
    } catch (error) {
      console.error("Error al gestionar favorito:", error);
      alert("Error al gestionar favorito. Por favor, inténtalo de nuevo.");
    }
  }, 300), [userToken, favoritos]);

  const compartirProducto = useCallback(throttle(async (e, producto) => {
    e.stopPropagation();
    e.preventDefault();
    
    if (!userToken) {
      alert("Debes iniciar sesión para compartir productos");
      return;
    }
    
    if (!producto) return;
    
    const productoId = getId(producto);
    if (compartiendo === productoId) return;
    
    try {
      setCompartiendo(productoId);
      
      const datosCompartir = {
        pedidoId: producto._id,
        usuarioId: userToken,
        nombreUsuario: "Usuario",
        productos: [
          {
            _id: producto._id || producto.id,
            nombre: producto.nombre || "Producto",
            precio: producto.precio || 0,
            cantidad: 1
          }
        ],
        fecha: new Date().toISOString()
      };

      const recomendacionCreada = await compartirPedido(datosCompartir);
      
      if (!recomendacionCreada || !recomendacionCreada._id) {
        throw new Error("No se pudo crear la recomendación");
      }

      const baseUrl = window.location.origin;
      const recomendacionId = recomendacionCreada._id;
      const enlaceCompartir = `${baseUrl}/recomendaciones/compartido/${recomendacionId}`;

      const mensajeCompartir = 
        `¡Mira este producto que te recomiendo en Romana! 🍽️\n\n` +
        `${producto.nombre}\n\n` +
        `👉 ${enlaceCompartir}`;

      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(mensajeCompartir)}`;
      window.open(whatsappUrl, '_blank');

      try {
        await navigator.clipboard.writeText(enlaceCompartir);
        alert(`Enlace copiado al portapapeles. Se ha abierto WhatsApp para compartir.`);
      } catch (clipboardError) {
        console.error("Error al copiar al portapapeles:", clipboardError);
        alert(`Se ha abierto WhatsApp. El enlace para compartir es: ${enlaceCompartir}`);
      }
    } catch (error) {
      console.error("Error al compartir producto:", error);
      alert("Error al compartir el producto. Por favor, inténtalo de nuevo.");
    } finally {
      setTimeout(() => {
        setCompartiendo(null);
      }, 1000);
    }
  }, 300), [userToken, compartiendo]);

  const normalizarId = (id) => {
    if (!id) return "";
    if (typeof id === 'object' && id.$oid) {
      return id.$oid.toString();
    }
    return id.toString().replace(/[{}"']/g, '');
  };

  const getImagenUrlAlergeno = (alergenoId) => {
    const idNormalizado = normalizarId(alergenoId);
    
    const alergeno = alergenos.find(a => {
      const aId = normalizarId(a._id || a.id);
      return aId === idNormalizado;
    });
    
    return alergeno && alergeno.img_url ? alergeno.img_url : null;
  };

  const AlergenaItem = ({ alergenoId }) => {
    const imgUrl = getImagenUrlAlergeno(alergenoId);
    
    if (!imgUrl) return null;
    
    const imagen = imagenesAlergenos[imgUrl];
    
    if (!imagen) return null;
    
    return (
      <div className={style.alergeno_item}>
        <img 
          src={imagen}
          alt="Alérgeno"
          className={style.alergeno_icono}
        />
      </div>
    );
  };

  const renderizarAlergenos = (producto) => {
    if (!producto.alergenos || !Array.isArray(producto.alergenos) || producto.alergenos.length === 0) return null;
    
    return (
      <div className={style.producto_alergenos_container}>
        <div className={style.producto_alergenos_iconos}>
          {producto.alergenos.map((alergenoId, index) => (
            <AlergenaItem key={index} alergenoId={alergenoId} />
          ))}
        </div>
      </div>
    );
  };
  
  const renderizarProducto = (producto) => {
    const productoId = getId(producto);
    const esFavorito = favoritos.includes(productoId);
    const estaCompartiendo = compartiendo === productoId;
    
    return (
      <div 
        className={style.favorito_container}
        key={productoId}
        onClick={() => onProductoClick(producto)}
      >
        <SwipeContainer className={style.producto_nombre_precio}>
          <div className={style.nombre_con_iconos}>
            <h3 className={style.producto_nombre}>
              {producto.nombre}
              <div className={style.iconos_producto}>
                <button 
                  className={`${style.boton_compartir_producto} ${estaCompartiendo ? style.compartiendo : ''}`}
                  onClick={(e) => compartirProducto(e, producto)}
                  title="Compartir"
                  aria-label="Compartir producto"
                  disabled={estaCompartiendo}
                >
                  <FaShareAlt size={14} />
                </button>
                <button 
                  className={`${style.boton_favorito} ${esFavorito ? style.active : ''}`}
                  onClick={(e) => handleFavorito(e, producto)}
                  title={esFavorito ? "Quitar de favoritos" : "Añadir a favoritos"}
                  aria-label={esFavorito ? "Quitar de favoritos" : "Añadir a favoritos"}
                >
                  <FaStar size={16} />
                </button>
              </div>
            </h3>
            {producto.precio && (
              <p className={style.producto_precio}>
                {producto.precio_unidad === false && producto.precio_peso === false 
                  ? `${parseFloat(producto.precio).toFixed(2)}€` 
                  : producto.precio_unidad === true 
                  ? `UD / ${parseFloat(producto.precio).toFixed(2)}€` 
                  : producto.precio_peso === true 
                  ? `KG / ${parseFloat(producto.precio).toFixed(2)}€` 
                  : ''}
              </p>
            )}
          </div>
          <div className={style.swipe_indicator}></div>
        </SwipeContainer>
        {producto.descripcion && producto.descripcion.toLowerCase() !== "nan" && (
          <p className={style.producto_descripcion}>{producto.descripcion}</p>
        )}
        {producto.tipo_bebida && producto.tipo_bebida.toLowerCase() !== "nan" && (
          <p className={style.producto_tipo_bebida}>{producto.tipo_bebida}</p>
        )}
        <div className={style.producto_info_container}>
          {producto.nombre && producto.nombre.includes("Pimientos del piquillo rellenos de guiso de manitas de cerdo") && (
            <img
              src={SoleteImage}
              className={style.solete}
              alt="Solete"
            />
          )}
          {renderizarAlergenos(producto)}
        </div>
      </div>
    );
  };

  return (
    <div className={style.productos_lista}>
      {cargando ? (
        <div className={style.loading_message}>
          {tipoCategoria ? "Cargando productos..." : "Cargando todos los productos..."}
        </div>
      ) : error ? (
        <div className={style.error_message}>
          <p>{error}</p>
        </div>
      ) : Object.keys(productosPorTipo).length > 0 ? (
        <>
          {tiposCategoriasData.map(tipo => {
            const tipoId = tipo._id || tipo.id;
            const productos = productosPorTipo[tipoId] || [];
            
            const productosPublicados = productos.filter(producto => producto.publicado);
            
            if (productosPublicados.length === 0) return null;
            
            return (
              <div key={tipoId} className={style.tipo_categoria_section}>
                <h4 className={style.tipo_categoria_titulo}>{tipo.nombre}</h4>
                <div className={style.productos_grupo}>
                  {productosPublicados.map(producto => renderizarProducto(producto))}
                </div>
              </div>
            );
          })}
        </>
      ) : null}
    </div>
  );
};

export default Productos;